// extracted by mini-css-extract-plugin
export default {"title":"V2-z","warning":"W2-z","sizeOptionsLegendText":"X2-z"};